/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedUnpurchasableHeader_item = {
    readonly title: string | null;
    readonly isSold: boolean | null;
    readonly " $refType": "PdpSharedUnpurchasableHeader_item";
};
export type PdpSharedUnpurchasableHeader_item$data = PdpSharedUnpurchasableHeader_item;
export type PdpSharedUnpurchasableHeader_item$key = {
    readonly " $data"?: PdpSharedUnpurchasableHeader_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedUnpurchasableHeader_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedUnpurchasableHeader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '627b8bf25ace6cbfa2920b636eb56e4e';
export default node;
